"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardRules = void 0;
exports.standardGetMovesWithSteps = standardGetMovesWithSteps;
const board_1 = require("../board");
const common_1 = require("../common");
const players_1 = require("../players");
const moves_1 = require("./moves");
const shared_1 = require("./shared");
function standardGetMovesWithSteps(state, steps) {
    if (steps.length === 0) {
        return {};
    }
    const playerPoints = (0, board_1.getPointsWithAtLeast)(state.board, state.turn, 1);
    const movesFromPoint = playerPoints.reduce((acc, from) => {
        const allMoves = (0, common_1.getAllMovesFromPoint)(state, from, steps);
        const movesList = allMoves.filter((moves) => (0, moves_1.isValidMoves)(state, moves));
        if (movesList.length > 0) {
            acc[from] = movesList.map((moves) => moves.map((move) => (0, common_1.addMoveInfo)(move, state)));
        }
        return acc;
    }, {});
    return movesFromPoint;
}
const standardFinalizeTurn = (state) => {
    return Object.assign(Object.assign({}, state), { turn: (0, players_1.opponent)(state.turn), dice: null });
};
exports.standardRules = (0, shared_1.createRules)({
    getMovesWithSteps: standardGetMovesWithSteps,
    finalizeTurn: standardFinalizeTurn,
    updateSteps: shared_1.standardUpdateSteps,
});
